import { useEffect } from "react";
import { useSelector } from "react-redux";

export const useDepartmentSchema = (formSchema: any[], targetLabel: "value" | "") => {
  const departmentOptions = useSelector(
    (state: any) => state.Login.departmentOptions
  );

  useEffect(() => {
    // console.log("@@@ departmentOptions",departmentOptions)
    if (!formSchema || !departmentOptions) return;

    const modifiedOptions = departmentOptions?.map((each: any) => ({
      label: each?.name,
      value: targetLabel === "value" ? each?.name : each.departmentId,
    }));

    // Update the formSchema in-place
    formSchema?.forEach((field: any) => {
      if (field.label === "Department") {
        field.options = modifiedOptions;
      }
    });
  }, [departmentOptions, formSchema, targetLabel]);
};
